import { path } from 'ramda'

import i18n from 'app/i18n'
import { Params } from 'app/common/types/identifiers/approve'

export const createIdentifierApproveError =
  (onNotFound: (identifierValue: string) => void) =>
  (error: Error, { identifierValue }: Params) => {
    const errorStatus: 'DISTRIBUTED_NOT_FOUND' | undefined = path(
      ['response', 'data', 'symbol'],
      error,
    )
    if (errorStatus === 'DISTRIBUTED_NOT_FOUND') {
      onNotFound(identifierValue)
      return ''
    }
    return i18n.t(
      'identifiers-next:identifier_entering_check_failed',
      'Не удалось получить информацию о номере идентификатора',
    )
  }
